module.exports = __webpack_public_path__ + "img/press-15.f0269109.jpg";